import { useSelector } from 'react-redux';
// 使用类型化的 selector hook
export const useAppSelector = useSelector;
